import { render, staticRenderFns } from "./InsuranceDictionaryMngtReg.vue?vue&type=template&id=4fc8fddc"
import script from "./InsuranceDictionaryMngtReg.vue?vue&type=script&lang=js"
export * from "./InsuranceDictionaryMngtReg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports